<template>
  <div class="project-image-gallery-section card-section">
    <div class="text-section-header">internal images</div>
    <div class="project-image-gallery">
      <v-card
        v-for="(imageData, i) in imageDatas"
        :key="`gallery-image-${i}`"
        class=" project-image-gallery__image-container"
        @click="handleImageClick(i)"
      >
        <v-img
          class="project_image_gallery__image"
          :src="imageData.link"
          aspect-ratio="1"
        />
      </v-card>
    </div>
    <v-overlay
      class="gallery-overlay"
      :value="modalOpen"
      @click.native="handleModalClick"
      opacity="0.7"
    >
      <div class="gallery-navigation">
        <div class="gallery-navigation__inner">
          <v-btn
            class="mx-2"
            fab
            dark
            large
            color="white"
            @click.stop="() => handleImageIndex('forward')"
          >
            <v-icon color="black" large>
              mdi-arrow-right
            </v-icon>
          </v-btn>
          <v-btn
            class="mx-2"
            fab
            dark
            large
            color="white"
            @click.stop="() => handleImageIndex('back')"
          >
            <v-icon color="black" large>
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </div>
      </div>
      <img
        :src="selectedImageData['link']"
        class="gallery-overlay-img"
        @click.stop=""
      />
      <div>{{ imageCaption }}</div>
      <DownloadImageSizesSelect
        v-if="!isSingleSize"
        :imageData="selectedImageData"
      />
    </v-overlay>
  </div>
</template>

<script>
// vuex
// library
// internal
// components
import DownloadImageSizesSelect from "@/components/SingleProject/DownloadImageSizesSelect";
export default {
  name: "PrivateImageGallery",
  components: {
    DownloadImageSizesSelect
  },
  data() {
    return {
      modalOpen: false,
      modalImageIndex: 0
    };
  },
  props: {
    imageDatas: {
      required: true,
      type: Array
    }
  },
  methods: {
    handleImageClick(index) {
      if (!this.modalOpen) {
        this.modalOpen = true;
        this.modalImageIndex = index;
      }
    },
    handleModalClick() {
      this.modalOpen = false;
    },
    handleModalImageClick(e) {
      console.log(e);
    },
    handleImageIndex(dir) {
      if (dir === "forward") {
        if (this.modalImageIndex === this.maxImageIndex) {
          this.modalImageIndex = 0;
        } else {
          this.modalImageIndex++;
        }
      } else {
        if (this.modalImageIndex === 0) {
          this.modalImageIndex = this.maxImageIndex;
        } else {
          this.modalImageIndex--;
        }
      }
    }
  },
  computed: {
    selectedImageData() {
      return this.imageDatas[this.modalImageIndex];
    },
    isSingleSize() {
      return this.selectedImageData.singleSize;
    },
    imageCaption() {
      return this.selectedImageData.caption ?? "";
    },
    maxImageIndex() {
      return this.imageDatas.length - 1;
    }
  }
};
</script>

<style lang="scss" scoped>
.project-image-gallery-section {
  .project-image-gallery {
    display: flex;
    flex-flow: row;
    flex-wrap: wrap;

    &__image-container {
      height: 135px;
      width: 135px;
      margin: 10px 20px 10px 0px;
      position: relative;
      cursor: pointer;
    }

    &__image {
    }
  }

  .gallery-overlay {
    .gallery-navigation {
      position: absolute;
      height: 100vh;
      width: 100vw;
      pointer-events: none;

      &__inner {
        display: flex;
        flex-flow: row-reverse;
        justify-content: space-between;
        padding: 10px;
        position: absolute;
        width: 100%;
        top: 50%;
        button {
          pointer-events: all !important;
        }
      }
    }
    .gallery-overlay-img {
      max-height: 80%;
      max-width: 80%;
    }

    .download-button {
      margin-top: 5px;
    }
  }
}
</style>
